import React, { createContext, useContext } from 'react';

/** Default values so nothing crashes before provider mounts */
const NotificationCenterContext = createContext({
    openNotifications: () => { },
    unreadCount: 0,
    notifVisible:false
});

export const NotificationCenterProvider = NotificationCenterContext.Provider;

/** Friendly hook */
export const useNotificationCenter = () => useContext(NotificationCenterContext);
